import { Text } from '@mantine/core'

import { useTranslation } from '@flecto/translations'
import { type CoreBookingPayment } from '@flecto/types'
import {
  DataTable,
  type DataTableColumn,
  type DataTableProps,
  TextDate,
  TextCurrency,
} from '@flecto/ui'

import { CellPaymentType } from './CellPaymentType'

export type TableBookingPaymentsProps = Omit<
  DataTableProps<CoreBookingPayment>,
  'columns'
> & {
  bookingPayments?: CoreBookingPayment[]
}

export function TableBookingPayments({
  bookingPayments,
  ...props
}: TableBookingPaymentsProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_payments' })

  const columns: DataTableColumn<CoreBookingPayment>[] = [
    {
      accessor: 'id',
      title: 'ID',
      width: 50,
      render: (_row, index) => {
        return <Text c='dimmed'>{index + 1}</Text>
      },
    },
    {
      accessor: 'type',
      title: t('table.type_header'),
      width: 150,
      render: (row) => <CellPaymentType payment={row} />,
    },
    {
      accessor: 'created_at',
      title: t('table.date_header'),
      render: (row) => <TextDate date={row.created_at} />,
    },
    {
      accessor: 'booking_amount_cents',
      title: t('table.rental_header'),
      render: (row) => <TextCurrency cents={row.booking_amount_cents} />,
    },
    {
      accessor: 'deposit_amount_cents',
      title: t('table.deposit_header'),
      render: (row) => <TextCurrency cents={row.deposit_amount_cents} />,
    },
    {
      accessor: 'booking_and_deposit_cents',
      title: t('table.total_header'),
      render: (row) => <TextCurrency cents={row.booking_and_deposit_cents} />,
    },
  ]

  return <DataTable {...props} columns={columns} records={bookingPayments} />
}
